import AccessControl from "@components/AccessControl";

import { useEpisode } from "../../../context";
import Cover from "../../Cover";
import Favorite from "../../Favorite";
import Footer from "../../Footer";
import Header from "../../Header";
import MetaActions from "../../MetaActions";
import PaywallNotice from "../../PaywallNotice";
import ShareEpisode from "../../ShareEpisode";
import TextMentions from "./TextMentions";

import styles from "./Text.module.css";

const TextEpisodeBody = () => {
  // Handle audio player, timeline etc here.
  const episode = useEpisode();
  const { hideActions, can_mark_favorite } = episode;

  return (
    <div className={styles.root} data-testid="audio-episode">
      <div className={styles.top}>
        <div className={styles.inner}>
          <Header />
          <PaywallNotice />
          <MetaActions />
          <TextMentions />
        </div>

        <div className={styles.cover}>
          <Cover episode={episode} />
          {!hideActions && can_mark_favorite && (
            <AccessControl>
              <Favorite className={styles.favorite} />
            </AccessControl>
          )}
          <ShareEpisode className={styles.share} />
        </div>
      </div>
      <Footer className={styles.footer} />
    </div>
  );
};

export default TextEpisodeBody;
